<script setup>
import { ref, onMounted } from "vue";
import { getExchangeRate } from "@/apis/exchangeRate";
import MobileMenu from "@/components/MobileMenu.vue";
import menuImageSrc from "@/assets/images/mobile/header/menu.svg";
import vectorImage from "@/assets/images/mobile/header/Vector.svg";

const rate = ref(null);
const isMobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};

const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
};

const goChatbot = () => {
  if (typeof window === "undefined") return;

  gtag("event", "Index_click", { action: "goChatbot", page: "hero" });
  if (localStorage.utm_ref != null) {
    window.open(
      "https://chatxbuy-springboard.web.app?ref=" + localStorage.utm_ref,
    );
  } else {
    window.open("https://chatxbuy-springboard.web.app");
  }
};

onMounted(async () => {
  const { exchange_rate } = await getExchangeRate();
  rate.value = exchange_rate;
});
</script>

<template>
  <div class="header">
    <div class="left-content">
      <div class="logo-wrapper">
        <router-link to="/">
          <img
            class="logo"
            src="@/assets/images/desktop/header/basic_logo_cn_l_1.png"
            alt="chatxbuy"
          />
        </router-link>
      </div>

      <!-- 匯率顯示 (僅桌面版) -->
      <p class="exchange-rate">
        今日匯率：新台幣
        <span class="exchange-rate-value">{{ rate }}</span>
      </p>
    </div>

    <!-- 漢堡選單 (僅手機版) -->
    <img
      class="hamburger-menu"
      :src="isMobileMenuOpen ? vectorImage : menuImageSrc"
      alt="menu"
      @click="toggleMobileMenu"
    />

    <!-- 導覽連結 (僅桌面版) -->
    <div class="mid-content">
      <div class="nav-wrapper">
        <div class="header-link header-text">
          <router-link class="header-router-link" to="/page/service">
            <span class="header-button-pointer">服務介紹</span>
          </router-link>
        </div>

        <div class="header-link header-text">
          <router-link class="header-router-link" to="/page/freight">
            <span class="header-button-pointer">費用說明</span>
          </router-link>
        </div>

        <div class="header-link header-text">
          <router-link class="header-router-link" to="/page/faq">
            <span class="header-button-pointer">Q&A</span>
          </router-link>
        </div>

        <div class="header-link header-text">
          <router-link class="header-router-link" to="/page/blogList">
            <span class="header-button-pointer">Blog</span>
          </router-link>
        </div>

        <div class="header-link header-text">
          <router-link class="header-router-link" to="/page/aboutUs">
            <span class="header-button-pointer">關於我們</span>
          </router-link>
        </div>

        <img
          class="chatbot-button"
          @click="goChatbot"
          src="@/assets/images/desktop/header/Primary.svg"
          alt="代買幫"
        />
      </div>
    </div>
  </div>

  <!-- 手機版選單 -->
  <MobileMenu :is-open="isMobileMenuOpen" @close="closeMobileMenu" />
</template>

<style scoped>
/* Mobile-first 基礎樣式 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 72px;
  width: 100%;
  padding-inline: 20px;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: white;
}

.left-content {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
}

.logo {
  width: 104px;
}

/* 匯率顯示 - 手機版隱藏 */
.exchange-rate {
  display: none;
  align-items: center;
  height: 100%;
  margin: 0;
}

.exchange-rate-value {
  color: #3c5bff;
  font-weight: 600;
  padding-inline: 4px;
}

/* 漢堡選單 - 手機版顯示 */
.hamburger-menu {
  display: block;
  margin-right: 22px;
  cursor: pointer;
}

/* 導覽連結 - 手機版隱藏 */
.mid-content {
  display: none;
  height: 100%;
}

.nav-wrapper {
  display: flex;
  justify-content: end;
  align-items: center;
  height: 100%;
}

.header-link {
  padding-left: 20px;
  padding-right: 20px;
  white-space: nowrap;
}

.header-text {
  font-family: PingFang TC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #3a3a3a;
}

.header-router-link {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  height: 100%;
}

.header-button-pointer {
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0;
}

.header-link:hover {
  color: #0751a0;
}

.chatbot-button {
  cursor: pointer;
  margin-left: 10px;
}

/* 桌面版樣式 (min-width: 1060px) */
@media (min-width: 1060px) {
  .header {
    padding-inline: 80px;
  }

  /* 顯示匯率 */
  .exchange-rate {
    display: flex;
  }

  /* 隱藏漢堡選單 */
  .hamburger-menu {
    display: none;
  }

  /* 顯示導覽連結 */
  .mid-content {
    display: table-cell;
    vertical-align: middle;
  }
}
</style>
